import _ from "lodash";
import { RoleType, User } from "./Users";

function notNull<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function getAllUserRoles<T extends RoleType>(users: User<T>[]): T[] {
  const memberRoles = _.flattenDeep(users.map(user => user.roles)).map(
    role => role
  );

  const uniqRoles = _.uniq(memberRoles);
  const usedRoles = _.sortBy(uniqRoles).filter(notNull);

  return usedRoles;
}
